function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable no-unused-expressions */
import Vue from 'vue';
import { sync, call, get } from 'vuex-pathify';
import { VForm } from 'vuetify/lib';
import EventBus from '@assets/scripts/event-bus';

var FormStep = /*#__PURE__*/function () {
  function FormStep() {
    _classCallCheck(this, FormStep);
  }

  _createClass(FormStep, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-form-step', {
        template: "<v-form\n        class=\"roche-form-step\"\n        v-bind=\"Object.assign({}, $props, $attrs)\"\n        v-on=\"$listeners\"\n        v-model=\"valid\"\n        v-show=\"stepIndex === currentStep && substepIndex <= currentSubStep\"\n        @submit=\"onSubmit\"\n        :class=\"{opacity: disableStep}\">\n          <div class=\"container--form\">\n            <div class=\"step\" v-if=\"substepIndex === 0 && !step.hidden && !(currentStep === 0 && currentSubStep === 0)\" v-show=\"!hideSteps\" @click.prevent=\"previousStep\">{{labels.previousStep}}<br></div>\n            <div class=\"content\">\n              <slot name=\"default\" v-bind:confirmCountry=\"confirmCountry\" v-bind:valid=\"valid\" v-bind:validate=\"validate\" v-bind:labels=\"labels\"/>\n              <div class=\"blocker\" v-if=\"disableStep\"></div>\n            </div>\n            <transition name=\"shrink\">\n              <div class=\"grid-x grid-margin-x\" v-show=\"substepIndex == currentSubStep\">\n                <div class=\"cell medium-12\">\n                  <div class=\"alert-message secondary\" role=\"alert\" v-if=\"showError\">\n                      {{errorMessage}}\n                  </div>\n                </div>\n                <div class=\"cell medium-8\">\n                </div>\n                <div class=\"cell medium-4 next-step\" v-show=\"!hideButtons\">\n                  <button class=\"button primary\" :class=\"{disabled: !valid}\" @click.prevent=\"validate\" v-if=\"!isLastStep\" ref=\"validate\">\n                    <span>{{labels.continue}}</span>\n                  </button>\n                  <button class=\"button primary\" :class=\"{disabled: !valid || this.$store.get('forms/showingLoader')}\" @click.prevent=\"validate\" v-else-if=\"form.occupation\" ref=\"validate\">\n                    <span>{{labels.submit}}</span>\n                  </button>\n                </div>\n              </div>\n            </transition>\n          </div>\n        </v-form>",
        components: {
          VForm: VForm
        },
        props: ['hideButtons', 'hideSteps', 'hideProgressbar'],
        data: function data() {
          return {
            valid: false,
            stepIndex: null,
            substepIndex: null,
            index: 0
          };
        },
        computed: {
          currentStep: sync('forms/currentStep'),
          currentSubStep: sync('forms/currentSubStep'),
          steps: sync('forms/steps'),
          labels: sync('forms/labels'),
          error: sync('forms/error'),
          id: get('forms/id'),
          form: sync('forms/form'),
          showError: sync('forms/showError'),
          errorMessage: sync('forms/errorMessage'),
          disableStep: function disableStep() {
            return this.substepIndex < this.currentSubStep;
          },
          isLastStep: function isLastStep() {
            var step = this.steps[this.currentStep];
            return this.currentStep + 1 === this.steps.length && this.currentSubStep + 1 === step.substeps;
          },
          step: function step() {
            return this.steps[this.currentStep] || {};
          },
          maxCount: function maxCount() {
            return Math.max.apply(Math, _toConsumableArray(this.steps.map(function (s) {
              return s.number;
            })));
          }
        },
        methods: {
          nextPage: call('forms/nextPage'),
          lastPage: call('forms/lastPage'),
          onSubmit: function onSubmit(e) {
            e.preventDefault();
          },
          previousStep: function previousStep() {
            this.lastPage();
          },
          validate: function validate() {
            this.$children[0].validate();
            this.$refs.validate.focus();

            if (this.valid && !this.form.flaggedcountries.includes(this.form.ctr)) {
              if (this.id === 'product-complaint' && this.step.number === 1) {
                this.$store.dispatch('forms/loadDosageForms');
              }

              this.nextPage();
              this.$root.$emit('step-changed');
              return true;
            }

            return false;
          },
          confirmCountry: function confirmCountry() {
            if (this.validate()) {
              window.digitalData.page.formInfo.formProgress.country = this.form.ctr;
              this.$store.dispatch('updateCountryCode', this.form.ctr);
            }
          },
          initSteps: function initSteps() {
            var _this = this;

            var index = 0;

            _toConsumableArray(document.querySelectorAll('[form-step]')).forEach(function (elStep, stepIndex) {
              index++;

              _toConsumableArray(elStep.querySelectorAll('form')).forEach(function (el, substepIndex) {
                if (_this.$el === el) {
                  _this.stepIndex = stepIndex;
                  _this.substepIndex = substepIndex;
                  _this.index = index;
                }
              });
            });
          }
        },
        mounted: function mounted() {
          var _this2 = this;

          var index = 0;

          _toConsumableArray(document.querySelectorAll('[form-step]')).forEach(function (elStep, stepIndex) {
            index++;

            _toConsumableArray(elStep.querySelectorAll('form')).forEach(function (el, substepIndex) {
              if (_this2.$el === el) {
                _this2.stepIndex = stepIndex;
                _this2.substepIndex = substepIndex;
                _this2.index = index;
              }
            });
          });

          EventBus.$on('update-steps', function () {
            _this2.initSteps();
          });
          this.$children[0] && this.$children[0].resetValidation();
          this.$nextTick(function () {
            _this2.$root.$emit('step-changed');

            _this2.$children[0] && _this2.$children[0].resetValidation();

            _this2.$nextTick(function () {
              _this2.$root.$on('step-changed', function () {
                if (_this2.stepIndex === _this2.currentStep && _this2.substepIndex === _this2.currentSubStep) {
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  });

                  _this2.$nextTick(function () {
                    var inputFound = false;
                    var index = 0;

                    while (!inputFound && index < _this2.$children[0].$el.length) {
                      var el = _this2.$children[0].$el[index];

                      if (el && (el.type === 'text' || el.type === 'textarea' || el.classList.contains('dz-button'))) {
                        el.focus();
                        inputFound = true;
                      }

                      index++;
                    }
                  });

                  if (window.analytics) {
                    window.analytics.totalSteps = String(index);

                    if (window.digitalData.page.attributes.country === 'Global' && window.analytics.step !== 0) {
                      window.analytics.step = String(_this2.index - 1);
                    } else {
                      window.analytics.step = String(_this2.index);
                    }
                  }

                  if (!_this2.$el.querySelector('.sidepanel-opener') && document.querySelector('.form-sidepanel')) {
                    document.querySelector('.form-sidepanel').classList.remove('open');
                  }
                }
              });
            });
          });
        }
      });
    }
  }]);

  return FormStep;
}();

export default FormStep;